import EmojiPluginIcon from './icons/EmojiPluginIcon.js';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import EmojiInsertModal from './modals/InsertModal.js';
import { EMOJI_TYPE, emojiModals } from './types.js';
import 'react';
import 'ricos-context';
import 'wix-rich-content-common';
import './toolbar/emojiPreviewModal.js';
import 'prop-types';
import 'react-custom-scrollbars';
import './icons/JoyPixelsIcon.js';
import './utils/getGroupEmojis.js';
import './utils/convertUnicodeToEmoji.js';
import './utils/emojiList.js';
import './constants.js';
import './icons/FaBell.js';
import './icons/FaFlag.js';
import './icons/FaHeart.js';
import './icons/FaPaw.js';
import './icons/FaSmile.js';
import './icons/FaPlane.js';
import './icons/FaUtensils.js';
import './icons/FaRegFutbol.js';
import 'wix-rich-content-ui-components';

const getAddButtons = (config, services) => {
  const {
    context: { isMobile = false }
  } = services || {};
  return isMobile ? [] : [
    {
      id: EMOJI_TYPE,
      label: INSERT_PLUGIN_BUTTONS.EMOJI,
      dataHook: INSERT_PLUGIN_BUTTONS.EMOJI,
      icon: EmojiPluginIcon,
      tooltip: "EmojiPlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => true,
      modal: {
        id: emojiModals.insert,
        Component: EmojiInsertModal
      },
      menuConfig: {
        tags: "Emoji_plugin_search_tags"
      }
    }
  ];
};

export { getAddButtons };
//# sourceMappingURL=getAddButtons.js.map
